<div *ngIf="accounts?.length; else notFound">
  <app-account-dashboard-charts *ngIf="accounts" [accounts]="accounts" [month]="month" (legendClicked)="onLegendClicked($event)"></app-account-dashboard-charts>
  <div *ngFor="let items of accounts | filter:filterAttribute:displayedLabels | groupBy:groupByAttribute">
    <app-account-expansion-table [accounts]="items" [month]="month" [panelTitle]="items[0].paidBy.name"
      [displayedColumns]="displayedColumns"></app-account-expansion-table>
  </div>
</div>
<ng-template #notFound>
  <mat-card *ngIf="accounts" class="message">
    登録がありません。
  </mat-card>
</ng-template>